import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import EnrolledCourse from "../../mylearning/enrolled-course";
import { useMyLearningContext } from "@root/context/my-learning-context";
import { Loader } from "@root/components/loader";
import { useTranslation } from "react-i18next";
import { Paginate } from "@root/components/pagination";
import { RECORDS_PER_PAGE, COURSE_ENROLLMENT_STATUS } from "@root/constants";
import { useMemo } from "react";

const EnrolledTab = () => {
  const {
    getMyLearningLoading,
    myLearningData,
    pageNo,
    setPageNo,
    pageCount,
    fetchMyLearning,
  } = useMyLearningContext();
  const { t } = useTranslation();

  const handlePageChange = (newPage: number) => {
    setPageNo(newPage);
    fetchMyLearning(
      { status: COURSE_ENROLLMENT_STATUS.ENROLLED },
      newPage
    );
  };

  // Filter out courses where enrollment period has ended
  const filteredCourses = useMemo(() => {
    if (!myLearningData?.rows) return [];
    
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
    
    return myLearningData.rows.filter((course: any) => {
      const courseData = course?.course;
      const enrollmentPeriodEnd = courseData?.enrollmentPeriodEnd;
      
      // If no enrollment period end date, include the course
      if (!enrollmentPeriodEnd) return true;
      
      // Check if enrollment period has ended
      const endDate = new Date(enrollmentPeriodEnd);
      endDate.setHours(0, 0, 0, 0);
      
      // Only include courses where enrollment period hasn't ended yet
      return today <= endDate;
    });
  }, [myLearningData?.rows]);

  const renderContent = () => {
    if (getMyLearningLoading) {
      return <Spinner size={"lg"} mt={"150px"} />;
    }
    if (!filteredCourses?.length) {
      return (
        <Text color={"#5C6670"} mt={"150px"}>
          {t("course.noDataFound")}
        </Text>
      );
    }
    return (
      <Box w="100%" gap="16px" display="flex" flexDirection="column">
        {filteredCourses.map((course: any, idx: number) => (
          <EnrolledCourse key={idx} course={course} />
        ))}
        {/* Pagination */}
        {pageCount > 0 && (
          <Box mt={6} display="flex" justifyContent="center">
            <Paginate
              marginTop={0}
              page={pageNo}
              count={pageCount}
              pageSize={RECORDS_PER_PAGE}
              onPageChange={handlePageChange}
              variant="ghost"
            />
          </Box>
        )}
      </Box>
    );
  };

  return renderContent();
};

export default EnrolledTab;
